import { Controller } from '@hotwired/stimulus'

// Handles date constraints between start and due date pickers in bulk forms
export default class extends Controller {
  static targets = ['startDate', 'dueDateInput']

  connect() {
    // Initial constraint update after datepickers initialize
    setTimeout(() => this.updateConstraints(), 100)
  }

  onStartDateChange() {
    this.updateConstraints()
  }

  onDueDateChange() {
    this.updateConstraints()
    // Uncheck lock to end of month when due date manually changed
    const lockCheckbox = this.element.querySelector('[data-bulk-lock-end-month]')
    const dueDateInput = this.element.querySelector('[data-bulk-due-date]')
    if (lockCheckbox && dueDateInput?.value) {
      lockCheckbox.checked = false
      dueDateInput.readOnly = false
      dueDateInput.style.opacity = ''
      dueDateInput.style.cursor = ''
    }
  }

  updateConstraints() {
    const startDateInput = this.element.querySelector('[data-bulk-start-date]')
    const dueDateInput = this.element.querySelector('[data-bulk-due-date]')

    if (!startDateInput || !dueDateInput) return

    const startDateController = this.application.getControllerForElementAndIdentifier(startDateInput, 'datepicker')
    const dueDateController = this.application.getControllerForElementAndIdentifier(dueDateInput, 'datepicker')

    if (!startDateController || !dueDateController) return

    // If start date has a value, set it as the minimum for due date
    if (startDateInput.value) {
      const startDate = this.parseDatepickerDate(startDateInput.value)
      dueDateController.setStartDate(startDate)
    } else {
      dueDateController.setStartDate(null)
    }

    // If due date has a value, set it as the maximum for start date
    if (dueDateInput.value) {
      const dueDate = this.parseDatepickerDate(dueDateInput.value)
      startDateController.setEndDate(dueDate)
    } else {
      startDateController.setEndDate(null)
    }
  }

  // Parse date from MM/DD/YYYY format (datepicker controller)
  parseDatepickerDate(dateStr) {
    if (!dateStr) return new Date()

    // Handle MM/DD/YYYY format
    const parts = dateStr.split('/')
    if (parts.length === 3) {
      const month = parseInt(parts[0], 10) - 1
      const day = parseInt(parts[1], 10)
      const year = parseInt(parts[2], 10)
      return new Date(year, month, day)
    }

    // Fallback to Date parsing
    return new Date(dateStr)
  }

  toggleLockEndMonth(event) {
    const dueDateInput = this.element.querySelector('[data-bulk-due-date]')
    const startDateInput = this.element.querySelector('[data-bulk-start-date]')

    if (event.currentTarget.checked) {
      const endOfMonthDate = this.calculateEndOfMonth(dueDateInput?.value, startDateInput?.value)

      if (dueDateInput) {
        dueDateInput.value = endOfMonthDate
        dueDateInput.readOnly = true
        dueDateInput.style.opacity = '0.5'
        dueDateInput.style.cursor = 'not-allowed'
      }
    } else {
      if (dueDateInput) {
        dueDateInput.readOnly = false
        dueDateInput.style.opacity = ''
        dueDateInput.style.cursor = ''
      }
    }
  }

  // Calculate end of month date - returns MM/DD/YYYY format for the datepicker controller
  calculateEndOfMonth(dueDate, startDate) {
    let baseDate

    if (dueDate) {
      baseDate = this.parseDatepickerDate(dueDate)
    } else if (startDate) {
      baseDate = this.parseDatepickerDate(startDate)
    } else {
      baseDate = new Date()
    }

    const year = baseDate.getFullYear()
    const month = baseDate.getMonth()
    const lastDay = new Date(year, month + 1, 0).getDate()

    const monthStr = (month + 1).toString().padStart(2, '0')
    const dayStr = lastDay.toString().padStart(2, '0')
    return `${monthStr}/${dayStr}/${year}`
  }
}
